import React from "react";
import { EditTextBlock } from "./EditTextBlock";
import { AdminActions } from "../Block/AdminActions";

export const AdminTextBlock = ({
  block,
  text,
  placeholder,
  onPropertyUpdate,
  onBlockUpdate,
  isActiveBlock,
  children,
}) => {
  const blockData = block || {};
  const currentText = text !== undefined ? text : blockData.text;
  const currentPlaceholder =
    placeholder !== undefined ? placeholder : blockData.placeholder;
  const isPullQuote = Boolean(
    blockData.isPullQuote || blockData.variant === "pull-quote"
  );
  const quoteAuthor = blockData.quoteAuthor;

  const handleTogglePullQuote = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    const nextIsPullQuote = !isPullQuote;
    const nextVariant = nextIsPullQuote ? "pull-quote" : "normal";
    if (onBlockUpdate) {
      onBlockUpdate({
        ...blockData,
        isPullQuote: nextIsPullQuote,
        variant: nextVariant,
      });
    } else if (onPropertyUpdate) {
      onPropertyUpdate("isPullQuote", nextIsPullQuote);
      onPropertyUpdate("variant", nextVariant);
    }
  };

  return (
    <EditTextBlock
      text={currentText}
      placeholder={currentPlaceholder}
      isPullQuote={isPullQuote}
      quoteAuthor={quoteAuthor}
      onUpdate={onPropertyUpdate}
      onTogglePullQuote={handleTogglePullQuote}
      isActiveBlock={isActiveBlock}
    >
      <AdminActions show={isActiveBlock}>
        {children}
      </AdminActions>
    </EditTextBlock>
  );
};
